module.exports = __webpack_public_path__ + "static/background_payoff-b9c5919f3bcea9eba168efc5b2ccedb5.jpg";